import { render, staticRenderFns } from "./BtnMostrarMetas.vue?vue&type=template&id=45401e47"
import script from "./BtnMostrarMetas.vue?vue&type=script&lang=js"
export * from "./BtnMostrarMetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports